import Cookie from 'universal-cookie';
// eslint-disable-next-line import/no-extraneous-dependencies
import { errors, importPKCS8, jwtDecrypt } from 'jose';
import * as type from '../constants/validarUsuario';
import * as types from '../constants/authActionTypes';
import * as serviceUser from '../services/identificarUsuario';
import menuDinamico from '../components/Menus/Menus';

const base64PrivateKey = process.env.REACT_APP_PRIVATE_KEY;

const UserInfo = {
  sesion: '',
  name: '',
  last_name: '',
  email: '',
  rol: '',
  code: '',
  mensaje: ''
};

// Convertir Uint8Array a un formato PKCS#8 utilizable
const privateKeyPem = `-----BEGIN PRIVATE KEY-----
${base64PrivateKey.match(/.{1,64}/g).join('\n')}
-----END PRIVATE KEY-----`;

// eslint-disable-next-line consistent-return
const decryptToken = async (token) => {
  try {
    // Importar la clave privada PKCS#8
    const privateKey = await importPKCS8(privateKeyPem, 'RSA-OAEP-256');
    const { payload } = await jwtDecrypt(token, privateKey);
    return payload;
  } catch (error) {
    if (error instanceof errors.JWTExpired) {
      console.error('El token ha expirado:', error.message);
    } else {
      console.error('Error desencriptando el JWT:', error.message);
    }
  }
};

let code = '';
export const initApp = () => async (dispatch) => {
  dispatch({ type: types.GET_MENU_LOADING });
  try {
    const coki = new Cookie();
    const cookie = coki.get('JWT-TOKEN-SIMAC');
    const userCons = await decryptToken(cookie);
    const peticion = {
      tipoAcceso: 2
    };
    const response = await serviceUser.identificarUsuario(peticion);
    dispatch({ type: types.GET_MENU_SUCCESS, payload: response.data.modulos });
    const { data } = response;
    code = data.code;
    if (data.code === 200) {
      const datas = data.modulos.menus;
      menuDinamico(datas);
    } else {
      return { success: false };
    }
    const payload = UserInfo;
    UserInfo.name = userCons.usuario;
    UserInfo.rol = userCons.rol;
    UserInfo.sesion = userCons.idSesion;
    UserInfo.code = code;
    UserInfo.message = data.causa;
    dispatch({ type: type.VALIDAR_SUCCESS, payload });
  } catch (error) {
    dispatch({ type: types.INIT_APP, payload: UserInfo || {} });
    console.log(error);
    dispatch({ type: types.GET_MENU_FAILURE, error });
    return { success: code };
  }
  dispatch({ type: types.INIT_APP, payload: UserInfo || {} });
  return { success: code };
};
